//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    item: {
      type: Object,
      default: () => {
        options: []
      },
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    len: {
      type: Number,
      default: 0,
    },
    curIndex: {
      type: Number,
      default: -1,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      curOwnId: '',
      actions: [
        { name: '编辑', code: 'edit', hanlder: this.edit },
        { name: '上移', code: 'up', hanlder: this.putDrag },
        { name: '下移', code: 'down', hanlder: this.putDrag },
        { name: '删除', code: 'delete', hanlder: this.delete },
      ],
    }
  },
  computed: {
    // 添加各种判断类型
    editableClass() {
      return []
    },
  },
  methods: {
    // 不支持编辑提示
    handlerTip() {
      new this.$Dialog({
        title: '提示',
        text: '当前题型不支持移动端编辑，请前往网页版问卷系统编辑',
      })
    },
    // 修改
    edit(type) {
      if (!this.canEdit) {
        this.handlerTip()
        return
      }
      this.$emit('hanlder', { type, item: this.item, index: this.curIndex })
    },
    // 删除
    delete(type) {
      this.$emit('hanlder', { type, item: this.item, index: this.curIndex })
    },
    // 上下移动
    putDrag(type) {
      this.$emit('hanlder', { type, item: this.item, index: this.curIndex })
    },
    // 当前块选中
    blockHandler() {
      this.$emit('block', this.item.v_ownId)
    },
  },
}
